import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BASE_URL || "";

export const getUserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return "UTC";
  }
};

export const verifyTicketStatusApi = async (data: {
  ticketId: string;
  userTimezone?: string;
}) => {
  return axios.get(`${baseUrl}/user/payment/scan-ticket`, {
    params: {
      ...data,
      userTimezone: data.userTimezone ?? getUserTimezone(),
    },
  });
};

const checkContentApiUrl = `${baseUrl}/museums/make-a-wish/check-content`;

export type MakeAWishContentCheckResult = {
  blocked: boolean;
  matchedWord?: string | null;
  blockedBy?: string | null;
  reason?: string | null;
};

/** Dry-run blocked-words check (same as tree-of-wisdom) — does not save a wish. */
export const checkMakeAWishContentApi = async (
  text: string
): Promise<MakeAWishContentCheckResult> => {
  const response = await axios.post(checkContentApiUrl, { text });
  return (response.data ?? { blocked: false }) as MakeAWishContentCheckResult;
};
